module.exports = __webpack_public_path__ + "static/img/ceshi.38bb77c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ceshi.png
// module id = 426
// module chunks = 1